// extracted by mini-css-extract-plugin
module.exports = {"languageItem":"languageDropdown_languageItem__1qBkE"};